import classes from "./BookingDatePicker.module.css";
import React, { useState, useEffect } from "react";
import { enGB } from "date-fns/locale";
import { DateRangePicker, START_DATE, END_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import "./calendarOveride.css";
//import { getDay } from 'date-fns'

import { useDispatch, useSelector } from "react-redux";

import { bookingActions } from "../../store/booking-slice";

import { FormatDate, convertDate, parseDate } from "../UI/Helper";

//Use below if you want to disable certain dates but remember you can still select over those dates so you need to fix that if you want to use it live!

//const disableDates = ["01 Sep 2024 ", "02 Sep 2024 ", "03 Sep 2024 ", "04 Sep 2024 ", "05 Sep 2024 ", "06 Sep 2024 ", "07 Sep 2024 ", "08 Sep 2024 ", "09 Sep 2024 ", "10 Sep 2024 "];

const disableDates = ["01 Sep 2024 ", "02 Sep 2024 "];

const modifiers = {
  disabled: (date) => disableDates.indexOf(FormatDate(date)) > -1,
};



const BookingDatePicker = () => {
  const dispatch = useDispatch();

  const checkInDate = useSelector((state) => state.booking.checkInDate);
  const checkOutDate = useSelector((state) => state.booking.checkOutDate);

  //const openingDate = parseDate(convertDate('24 Dec 2021'), 'dd/mm/yyyy')
  const openingDate = new Date();

  //const maxDate = parseDate(convertDate('31 Dec 2022'), 'dd/mm/yyyy')

  const maxDate = new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  );

  let initOpeningDate = null;
  let initCheckOutDate = null;

  if (checkInDate) {
    initOpeningDate = parseDate(convertDate(checkInDate), "dd/mm/yyyy");
  }

  if (checkOutDate) {
    initCheckOutDate = parseDate(convertDate(checkOutDate), "dd/mm/yyyy");
  }

  const [startDate, setStartDate] = useState(initOpeningDate);
  const [endDate, setEndDate] = useState(initCheckOutDate);

  const dateTouched = useSelector((state) => state.booking.checkOutDate);


  useEffect(() => {
    if (checkInDate && checkOutDate) {
      const parsedStart = parseDate(convertDate(checkInDate), "dd/mm/yyyy");
      const parsedEnd = parseDate(convertDate(checkOutDate), "dd/mm/yyyy");

      setStartDate(parsedStart);
      setEndDate(parsedEnd);
    }
  }, [checkInDate, checkOutDate]);

  useEffect(() => {
    if (!endDate && !dateTouched) {
      setStartDate(null);
    }
  }, [endDate, dateTouched]);

  useEffect(() => {
    if (!dateTouched) {
      dispatch(
        bookingActions.setDateCalendarTouched({
          dateCalendarTouched: true,
        })
      );
    }

    if (startDate && endDate) {
      dispatch(
        bookingActions.setBookingDates({
          checkIn: FormatDate(startDate),
          checkOut: FormatDate(endDate),
        })
      );
    }
  }, [startDate, endDate, dispatch, dateTouched]);

  return (
    <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      onStartDateChange={setStartDate}
      onEndDateChange={setEndDate}
      minimumDate={openingDate}
      maximumDate={maxDate}
      minimumLength={5}
      maximumLength={22}
      format="dd MMM yyyy"
      locale={enGB}
      modifiers={modifiers}
    >
      {({ startDateInputProps, endDateInputProps, focus }) => (
        <div className="date-range">
          <input
            className={
              classes.calendarIcon +
              " " +
              classes.bookingDateInput +
              " dateInput" +
              (focus === START_DATE ? " -focused" : "")
            }
            {...startDateInputProps}
            placeholder="Check In Date"
            // value={startDate}
          />
          <span className="date-range_arrow" />
          <input
            className={
              classes.calendarIcon +
              " " +
              classes.bookingDateInput +
              " dateInput" +
              (focus === END_DATE ? " -focused" : "")
            }
            {...endDateInputProps}
            placeholder="Check Out Date"
            // value={endDate}
          />
        </div>
      )}
    </DateRangePicker>
  );
};

export default BookingDatePicker;
